import { render, staticRenderFns } from "./MemberShipBrand.vue?vue&type=template&id=dd4d237a&"
import script from "./MemberShipBrand.vue?vue&type=script&lang=js&"
export * from "./MemberShipBrand.vue?vue&type=script&lang=js&"
import style0 from "./MemberShipBrand.vue?vue&type=style&index=0&id=dd4d237a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports